import { useConfigurationQuery } from '@lingoda/monolith-graphql';
import { usePaymentCallbacksForSubscriptionChange } from '@lingoda/payments';
import CheckoutForm from '../CheckoutForm';
import type { ContainerCommonProps } from './types';

type Props = ContainerCommonProps;

const CheckoutSubscriptionChange = ({
    asyncValidating,
    purchase,
    submitLabel,
    terms,
    testChargeLabel,
}: Props) => {
    const currency = purchase.total.currency;
    const { data: configData } = useConfigurationQuery();
    const newSectionName =
        purchase?.__typename === 'SubscriptionPurchase' ? purchase.newSection?.name : undefined;
    const newCurriculumId =
        purchase?.__typename === 'SubscriptionPurchase' ? purchase.curriculum?.id : undefined;

    // TODO: change minimumCharge type to Record<Currency, number> on server side
    const minimumCharge = configData?.config.minimumCharges[currency] as number | undefined;
    const [handlePaymentSubmit, fetchIntentSecret] = usePaymentCallbacksForSubscriptionChange(
        purchase,
        newSectionName,
        newCurriculumId,
    );

    return (
        <CheckoutForm
            purchase={purchase}
            chargeAmount={minimumCharge}
            onSubmitPaymentCallback={handlePaymentSubmit}
            fetchIntentSecretCallback={fetchIntentSecret}
            asyncValidating={asyncValidating}
            submitLabel={submitLabel}
            terms={terms}
            testChargeLabel={testChargeLabel}
            isSubscriptionChange
        />
    );
};

export default CheckoutSubscriptionChange;
